export const renderComponentIf = (state) => (component) =>
  state ? component : null;
